import { Component } from '@angular/core';
import { NgClass, NgFor, NgIf, CommonModule } from '@angular/common';
import { FooterComponent } from '../../components/footer/footer.component';
import { HeaderComponent } from '../../components/header/header.component';
import { DatasearchService } from '../../_services/datasearch.service';

@Component({
  selector: 'app-our-partners',
  standalone: true,
  imports: [HeaderComponent, FooterComponent, NgFor, NgIf, NgClass, CommonModule],
  templateUrl: './our-partners.component.html',
  styleUrl: './our-partners.component.scss'
})
export class OurPartnersComponent {
  transparent = false;
  selectedItem: number = 0;
  partners: any = [];
  head: any[] = [];
  currentPage: string = 'partner';
  logoBaseUrl: string;
  currentUrl: string;

  constructor(private datasearch: DatasearchService) {
    this.currentUrl = window.location.href; // Get the current URL
    this.logoBaseUrl = this.datasearch.ApiUrl; // We append the partner path dynamically later if needed, or set it directly
  }

  ngOnInit() {
    this.selectedItem = 0;
    this.getPartnerData();
    this.getHeading();

  }

  getPartnerData() {
    this.datasearch.getPartners().subscribe(res => {
      // Filter only active partners
      this.partners = res.data.filter((partner: any) => partner.isActive === true);
    });
  }

  selectItem(index: number) {
    this.selectedItem = index;
  }

  getPartnerLogo(partner: any): string {
    if (!partner || !partner.logo_1) return 'https://www.chemrobotics.com/uploads/gallery/placeholder.png';
    let filename = partner.logo_1;
    if (filename.startsWith('http')) return filename;

    // Prevent double pathing by checking if "uploads/" is already present
    let cleanPath = filename.replace(/^\//, ''); // Remove leading slash if any

    if (!cleanPath.includes('uploads/')) {
      cleanPath = 'uploads/partners/' + cleanPath;
    }

    // Ensure accurate prefix for the final URL (strip trailing slashes from ApiUrl)
    const baseUrl = this.datasearch.ApiUrl.replace(/\/$/, '');
    return `${baseUrl}/${cleanPath}`;
  }

  getHeading() {
    this.datasearch.getAllHeadings().subscribe(res => {
      if (res.success) {
        this.head = res.data.filter((heading: any) => heading.page === this.currentPage);
      }
    });
  }

  openLink(url: string) {
    if (url) {
      window.open(url, '_blank');
    }
  }

  getPartnerWebLink(partner: any): string {
    if (!partner) return '';
    // Standard property names
    const possibleKeys = ['web_link', 'partner_link', 'link', 'weblink', 'website', 'url', 'web_url', 'web_link_url'];
    for (const key of possibleKeys) {
      if (partner[key] && partner[key] !== 'null' && partner[key] !== 'undefined') return String(partner[key]).trim();
    }
    // Fallback: Smart search for anything link-related (avoiding images/logos)
    for (const key in partner) {
      const k = key.toLowerCase();
      if ((k.includes('link') || k.includes('url') || k.includes('website'))
        && !k.includes('image') && !k.includes('logo') && !k.includes('poster') && !k.includes('thumb')) {
        const val = partner[key];
        if (val && val !== 'null' && val !== 'undefined') return String(val).trim();
      }
    }
    return '';
  }
  shareViaEmail() {
    const subject = 'Check out this page!';
    const body = `Here is the link: ${this.currentUrl}`;
    const mailtoLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    window.location.href = mailtoLink; // Open the email client
  }

  shareViaSMS() {
    const smsLink = `sms:?body=${encodeURIComponent(this.currentUrl)}`;
    window.location.href = smsLink; // Open SMS app
  }

  shareViaWhatsApp() {
    const text = `Check this out! ${this.currentUrl}`;
    const whatsappLink = `https://wa.me/?text=${encodeURIComponent(text)}`;

    window.open(whatsappLink, '_blank'); // Open WhatsApp share dialog
  }

  shareViaMessenger() {
    const messengerLink = `https://www.messenger.com/share/?link=${encodeURIComponent(this.currentUrl)}`;
    window.open(messengerLink, '_blank'); // Open Messenger share dialog
  }

  shareViaViber() {
    const viberLink = `viber://forward?text=${encodeURIComponent(this.currentUrl)}`;
    window.open(viberLink, '_blank'); // Open Viber share dialog
  }

  shareViaFacebook() {
    const facebookLink = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.currentUrl)}`;

    window.open(facebookLink, '_blank'); // Open Facebook share dialog
  }

  shareViaTwitter() {
    const text = `Check this out! ${this.currentUrl}`;
    const twitterLink = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`;

    window.open(twitterLink, '_blank'); // Open Twitter share dialog
  }

  shareViaLinkedIn() {
    const linkedInLink = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(linkedInLink, '_blank'); // Open LinkedIn share dialog
  }

  shareViaPinterest() {
    const pinterestLink = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(pinterestLink, '_blank'); // Open Pinterest share dialog
  }

  shareViaReddit() {
    const redditLink = `https://www.reddit.com/submit?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(redditLink, '_blank'); // Open Reddit share dialog
  }

  shareViaTumblr() {
    const tumblrLink = `https://www.tumblr.com/share/link?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(tumblrLink, '_blank'); // Open Tumblr share dialog
  }

  shareViaTelegram() {
    const telegramLink = `https://t.me/share/url?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(telegramLink, '_blank'); // Open Telegram share dialog
  }

  shareViaVK() {
    const vkLink = `https://vk.com/share.php?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(vkLink, '_blank'); // Open VK share dialog
  }

  shareViaMix() {
    const mixLink = `https://mix.com/add?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(mixLink, '_blank'); // Open Mix share dialog
  }

  shareViaXing() {
    const xingLink = `https://www.xing.com/app/user?op=share;url=${encodeURIComponent(this.currentUrl)}`;
    window.open(xingLink, '_blank'); // Open Xing share dialog
  }

  shareViaLine() {
    const lineLink = `https://line.me/R/share?text=${encodeURIComponent(this.currentUrl)}`;
    window.open(lineLink, '_blank'); // Open Line share dialog
  }

  copyLink() {
    navigator.clipboard.writeText(this.currentUrl).then(() => {
      alert('Link copied to clipboard!');
    });
  }
}